import {luscinia} from "./luscinia";

luscinia.sendReportEmail = async function() {
    const formData = buildSendReportEmailFormData($("#send-report-email"));    
    const modalForm = document.querySelector(".modal-form") as HTMLFormElement;
    const reportName = modalForm.dataset.reportName;

    await fetch(`/send-report-email/${reportName}`, {
        method: "POST",
        body: formData
    });

    luscinia.closeAllModals();
}

export function buildSendReportEmailFormData(form: JQuery<HTMLFormElement>) {
    const formData = luscinia.serializeFormObject($(".modal-form"));
    const emailParameterFormData = luscinia.serializeFormObject(form);

    for (const [key, val] of emailParameterFormData.entries()) {
        formData.append(`email-report-${key}`, val);
    }
    return formData;
}
